import { render, staticRenderFns } from "./Purchased.vue?vue&type=template&id=14e0107a&scoped=true"
import script from "./Purchased.vue?vue&type=script&lang=js"
export * from "./Purchased.vue?vue&type=script&lang=js"
import style0 from "./Purchased.vue?vue&type=style&index=0&id=14e0107a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e0107a",
  null
  
)

export default component.exports